import styles from './styles.module.less';

export const ALIGN_CLASSES = {
  right: styles.alignRight,
  center: styles.alignCenter,
  left: styles.alignLeft,
};

export const COLUMN_TYPES = {
  NUMBER: 'number',
  STRING: 'string',
  DATE: 'date',
  ARRAY_LENGTH: 'arrayLength',
  NESTED: 'nested',
};

export const RESPONSIVE_COLUMN_TYPE = {
  ACTIONS: 'actions',
};

export const ACTIONS_LAYOUT = {
  START: 'start',
  CENTER: 'center',
  END: 'end',
  BETWEEN: 'between',
  AROUND: 'around',
};

export const ACTIONS_LAYOUT_CLASSES = {
  [ACTIONS_LAYOUT.START]: styles.actionsLayoutStart,
  [ACTIONS_LAYOUT.CENTER]: styles.actionsLayoutCenter,
  [ACTIONS_LAYOUT.END]: styles.actionsLayoutEnd,
  [ACTIONS_LAYOUT.BETWEEN]: styles.actionsLayoutBetween,
  [ACTIONS_LAYOUT.AROUND]: styles.actionsLayoutAround,
};
